import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  CircularProgress,
  Alert,
  IconButton,
  InputAdornment,
} from '@mui/material';
import ViewKanbanIcon from '@mui/icons-material/ViewKanban';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { authActions } from '../../store';
import { LOG_IN } from '../../store/auth/auth.types';

export const LoginPage = () => {
  const dispatch = useDispatch();
  const httpOnLoad = useSelector((state) => state.httpOnLoad);
  const httpOnError = useSelector((state) => state.httpOnError);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const isLoading = httpOnLoad?.some((i) => i.type === LOG_IN);
  const error = httpOnError?.find((i) => i.type === LOG_IN);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(authActions.logIn({ email, password }));
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'action.hover',
      }}
    >
      <Card sx={{ width: 420, boxShadow: '0 4px 24px rgba(0,0,0,0.08)' }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 3 }}>
            <ViewKanbanIcon sx={{ color: 'primary.main', fontSize: 36 }} />
            <Typography variant="h4" sx={{ fontWeight: 700, color: 'text.primary' }}>
              TaskQ
            </Typography>
          </Box>
          <Typography variant="h6" align="center" sx={{ mb: 3, color: 'text.secondary' }}>
            Sign in to your account
          </Typography>
          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error.error || 'Login failed'}
            </Alert>
          )}
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              required
              autoFocus
            />
            <TextField
              fullWidth
              label="Password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              margin="normal"
              required
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end" size="small">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={isLoading}
              sx={{ mt: 3, mb: 2, textTransform: 'none', fontWeight: 600 }}
            >
              {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Sign In'}
            </Button>
          </form>
          <Typography align="center" variant="body2" sx={{ color: 'text.secondary' }}>
            Don't have an account?{' '}
            <Link to="/register" style={{ color: 'inherit', fontWeight: 600 }}>
              Sign Up
            </Link>
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};
